export default function () {
  if (window.scrollY === undefined) {
    return document.documentElement.scrollTop
  }

  return window.scrollY
}
